import React from "react";
import { PhoneCall, GraduationCap, UsersRound, LineChart, ShieldCheck, Headset } from "lucide-react";

const SERVICES = [
    {
        icon: PhoneCall,
        title: "Targeted Outreach",
        copy:
            "Curated calling campaigns to qualified prospects across 50+ markets. Compliance-first, conversation-second, conversion-third.",
        span: "md:col-span-7",
    },
    {
        icon: GraduationCap,
        title: "Trader Education",
        copy:
            "We walk clients through platform mechanics, instrument selection, and risk frameworks before they fund their first account.",
        span: "md:col-span-5",
    },
    {
        icon: UsersRound,
        title: "Client Onboarding Concierge",
        copy:
            "Hand-held registration, KYC support, deposit guidance — bridging prospects into Vantage's onboarding pipeline.",
        span: "md:col-span-5",
    },
    {
        icon: LineChart,
        title: "Account Strategy Match",
        copy:
            "Aligning each trader with the optimal account type: Standard STP, RAW ECN, Pro ECN, or Cent — based on style and volume.",
        span: "md:col-span-7",
    },
    {
        icon: ShieldCheck,
        title: "Regulatory Walkthroughs",
        copy:
            "We explain Vantage's licenses, segregation policy, and protections so traders deposit with full clarity.",
        span: "md:col-span-4",
    },
    {
        icon: Headset,
        title: "Continuous Client Care",
        copy:
            "Post-onboarding check-ins, platform escalation routing, and feedback loops back to Vantage's product teams.",
        span: "md:col-span-4",
    },
    {
        icon: PhoneCall,
        title: "Partner & IB Channels",
        copy:
            "Building introducer broker relationships and affiliate funnels that perform on substance, not surface.",
        span: "md:col-span-4",
    },
];

export default function Services() {
    return (
        <section
            id="services"
            className="section bg-[#1B2870] border-y border-white/5"
            data-testid="services-section"
        >
            <div className="container-x">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
                    <div>
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#C8A064]" />
                            <span className="overline">Services</span>
                        </div>
                        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#F3F4F6] leading-tight max-w-3xl">
                            Seven disciplines.{" "}
                            <em className="text-[#C8A064] not-italic">One outcome.</em>
                        </h2>
                    </div>
                    <p className="text-[#94A3B8] max-w-md text-sm leading-relaxed">
                        Every service we offer is engineered to introduce, educate, and retain
                        Vantage clients with integrity — not gimmicks.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
                    {SERVICES.map((s, i) => (
                        <ServiceCard key={i} {...s} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}

const ServiceCard = ({ icon: Icon, title, copy, span, index }) => (
    <div
        className={`card-solid card-hover p-8 ${span} group`}
        data-testid={`service-card-${index}`}
    >
        <div className="flex items-start mb-8">
            <div className="w-12 h-12 border border-[#C8A064]/40 flex items-center justify-center text-[#C8A064] group-hover:bg-[#C8A064]/10 transition-colors">
                <Icon size={20} strokeWidth={1.6} />
            </div>
        </div>
        <h3 className="font-serif-display text-2xl text-[#F3F4F6] mb-3 leading-snug">{title}</h3>
        <p className="text-sm text-[#94A3B8] leading-relaxed">{copy}</p>
    </div>
);
